export default __webpack_public_path__ + "static/media/Group.21e1d52d.svg";